import registerFocus from './custom/cyc' // 获取焦点
import dropUpload from './custom/dropUpload'
import registerSafeHtml from './custom/safeHtml' // v-html 的净化版本
export default function registerDirectives(app) {
  registerFocus(app)
  dropUpload(app)
  registerSafeHtml(app)
}
